import React, { useEffect, useState } from 'react';
import ReactSelect from '@common/ReactSelect';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { leadListFilters } from '@src/store/slices/insurance';
import {APP_TYPE_AGENCY, DEFAULT_PAGE_NO, LEAD_LIST_FILTER,STATUS_TYPE} from '@src/config/constant';
import * as HELPER from "@src/config/helper";
import DatePicker from "react-multi-date-picker";


const InsuranceListTopFilter = (props: any) => {
    const dispatch: any = useDispatch();
    const [selectedFilters, setSelectedFilters] = useState<any>({});
    const [dateFilters, setDateFilters] = useState<any>([]);
    const insuranceState = useSelector((state: any) => state.insurance)
    // const commonState = useSelector((state: any) => state.common)
    const [showDateRangeCdr, setShowDateRangeCdr] = useState(false);

    const [errField, setErrField] = useState<any>({
        date_range : "",
    });
     
    useEffect(() => {
        if (Object.keys(insuranceState.insuranceListFilters).length) {
            let insuranceListFilters:any={...insuranceState.insuranceListFilters};
            let dateFilter:any=[]
            
            if(insuranceListFilters.status_type==="pending_payment"){
                dateFilter=LEAD_LIST_FILTER.pendingPaymentFilters;
            }else{
                dateFilter=LEAD_LIST_FILTER.taskSummaryFilters;
            }
            if(insuranceListFilters.datetype==="cdr"){
                setShowDateRangeCdr(true);
            }else{
                setShowDateRangeCdr(false);
            }
            setDateFilters([...dateFilter]);
            setSelectedFilters(insuranceListFilters);
        }
    }, [insuranceState.insuranceListFilters])

    const handleChangeDateType = (selectedOption: any, key: string) => {
        let updatedFilters: any = {...selectedFilters};
        if (selectedOption.length === 2) {
            updatedFilters["from_date"] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
            updatedFilters["to_date"] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
        } else {
            updatedFilters["from_date"] = selectedOption[0]?.format("YYYY-MM-DD");
            updatedFilters["to_date"] = null; // Reset end date
        }
        setSelectedFilters(updatedFilters);
        dispatch(leadListFilters(updatedFilters));

    }

    const handleChange = (selectedOption: any, key: string) => {
        let updatedFilters = selectedFilters;
        if (key === "raised_soa") {
            updatedFilters = { ...updatedFilters, raised_soa: +selectedOption.target.value};
        }else if(key==="datetype"){
            let value=selectedOption.value;
            if(value!=="cdr"){
                let {from_date,to_date}:any= HELPER.dateReturn(value);
                if(value==="all") delete updatedFilters["from_date"];
                if(from_date){
                    updatedFilters = { ...updatedFilters, from_date: from_date};
                }
                if(to_date){
                    updatedFilters = { ...updatedFilters, to_date: to_date};
                }
                setShowDateRangeCdr(false);
            }else{
                delete updatedFilters["from_date"];
                delete updatedFilters["to_date"];
                setShowDateRangeCdr(true);
            }
            updatedFilters = { ...updatedFilters, datetype: value};
        }
        setSelectedFilters(updatedFilters);
        dispatch(leadListFilters(updatedFilters));
    }
     /**
     * FILTER SEARCH HANDLER
     */
     const onFilterSearch = () => {
        if (selectedFilters.datetype === "cdr") {
            const { from_date, to_date } = selectedFilters;
            if (!from_date || !to_date) {
                setErrField({
                    ...errField,
                    date_range: "From date and To date are required.",
                });
                return; // Stop execution if validation fails
            }
            if (new Date(to_date) <= new Date(from_date)) {
                setErrField({
                    ...errField,
                    date_range: "To Date cannot be earlier than From Date.",
                });
                return; // Stop execution if validation fails
            }
            // Clear errors if validation passes
            setErrField({
                ...errField,
                date_range: "",
            });
        }
        props.submitHandler({ ...selectedFilters,page_number: 1});
    }

    /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
        let date_type=(selectedFilters?.status_type===STATUS_TYPE[2].value)? LEAD_LIST_FILTER?.pendingPaymentFilters[0].value:LEAD_LIST_FILTER?.taskSummaryFilters[1].value;
        if(date_type){
            let {from_date,to_date}:any= HELPER.dateReturn(date_type);

            let updatedFilters = {status_type:selectedFilters?.status_type, page_number: DEFAULT_PAGE_NO,datetype:date_type,from_date:from_date,to_date:to_date,apptype:APP_TYPE_AGENCY,lead_type:6,};
            setShowDateRangeCdr(false);
            setSelectedFilters(updatedFilters);
            dispatch(leadListFilters(updatedFilters));
            props.updateUrl(updatedFilters,"resetAll");
        }
    }


    const downloadPolicies = async () => {
        const { page_number, datetype, ...param } = selectedFilters;
        props.downloadPolicyZip({ ...param});
    }

    

    
    
    return (
        <React.Fragment>
            <h3>Filters</h3>
            <div className="lead-list-filter">
                <div className="filter-filed-form">
                  
                        <ReactSelect 
                            options={dateFilters} 
                            value={(Object.keys(selectedFilters).length > 0 && dateFilters.length > 0 && dateFilters.find((v: any) => selectedFilters['datetype'] === v.value)) || null}
                            handleChange={(e: any) => handleChange(e, 'datetype')}
                            placeholder="Select Duration" 
                            fieldSetClassName=""
                            fieldKey="datetype" />
                 
                    {
                       showDateRangeCdr && 
                        <fieldset className='multi-datepicker datepicker'>
                            <div className={(selectedFilters && selectedFilters?.from_date)?`material animation-effect active-label`:`material animation-effect`}>
                                <DatePicker
                                    value={[selectedFilters?.from_date, selectedFilters?.to_date]}
                                    onChange={(e: any) => handleChangeDateType(e, 'cdr')}
                                    placeholder=""
                                    range
                                />
                                <label title="" data-label="Date Range*" className="form-label datepick-heading"></label>
                                {errField.date_range && (
                                    <span className="error-txt date-range-error">
                                        {errField['date_range'] || ""}
                                    </span>
                                )}
                            </div>
                        </fieldset> 
                    }
                    {
                      (Object.keys(selectedFilters).length && selectedFilters.status_type==="pending_payment") &&   
                         <fieldset className="radio-type-txt d-flex  radio-btn">
                             <label className="form-label">Raised SOA</label>
                            <div className="custom-control custom-checkbox">
                                <input 
                                id="raised_soa_yes" 
                                type="radio" 
                                className="custom-control-input" 
                                name="raised_soa" 
                                value="1"
                                checked={selectedFilters && selectedFilters["raised_soa"] === 1}
                                onChange={(e: any) => handleChange(e,"raised_soa")}
                                />
                                <label className="custom-control-label">Yes </label>
                            </div>
                            <div className=" custom-control custom-checkbox m-lg-l">
                                <input 
                                id="raised_soa_no" 
                                type="radio" 
                                className="custom-control-input" 
                                name="raised_soa" 
                                value="0"
                                checked={selectedFilters && selectedFilters["raised_soa"] === 0} 
                                onChange={(e: any) => handleChange(e,"raised_soa")} />

                                <label className="custom-control-label">No</label>
                            </div>
                        </fieldset>
                    }
                    <div className="btn-submit-reset">
                        <button className="btn-primary" onClick={onFilterSearch}>Search</button>
                        <button className="btn-reset" onClick={onFilterReset}>Reset</button>
                    </div>
                    {
                        (Object.keys(selectedFilters).length && selectedFilters.status_type==="policy_issued") && props.insuranceCount > 0 &&
                        <div className="right-buttons">
                            <button className="btn-primary downloadPolicyBtn" onClick={downloadPolicies} disabled={props.idDownloading}>{props.idDownloading ? "Downloading in Process..." : "Download All Policies"}</button>
                        </div>
                    }
                </div>
               
            </div>
        </React.Fragment>
    );
};

export default InsuranceListTopFilter;
